var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1188,
    height: 958,
    viewBox: "0 0 1188 958",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M774.094 265.271C669.619 143.574 496.561 115.772 496.561 115.772C496.561 115.772 634.258 45.0678 778.246 5.35754C824.484 -7.40147 874.138 2.88805 911.078 33.4553C936.75 54.654 957.414 81.2699 971.589 111.395C985.763 141.52 993.097 174.408 993.064 207.701V748.416C993.064 842.587 935.494 923.338 853.625 957.323L838.059 476.581C838.059 476.581 832.451 333.248 774.094 265.271Z",
    fill: "#C47E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.971 265.271C323.445 143.574 496.504 115.772 496.504 115.772C496.504 115.772 358.807 45.0678 214.818 5.35754C168.581 -7.40147 118.926 2.88805 81.9863 33.4553C56.3141 54.654 35.6501 81.2699 21.4756 111.395C7.30117 141.52 -0.0326002 174.408 0.000108934 207.701V748.416C0.000108934 842.587 57.5706 923.338 139.439 957.323L155.006 476.581C155.006 476.581 160.614 333.248 218.971 265.271Z",
    fill: "#C47E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M853.064 957.125L821.498 476.384C821.498 476.384 815.89 349.051 757.533 281.074C740.325 261.028 721.689 243.096 702.564 227.125C693.694 219.718 684.717 212.732 675.729 206.152C675.507 205.985 675.285 205.823 675.064 205.666C675.286 205.828 675.508 205.99 675.729 206.152C687.629 215.096 702.564 239.415 702.564 261.574V676.402C702.564 716.913 714.867 756.439 737.843 789.804L853.064 957.125Z",
    fill: "#CE9578"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140 957.125L171.567 476.384C171.567 476.384 177.175 349.051 235.531 281.074C252.74 261.028 271.375 243.096 290.5 227.125C299.371 219.718 308.347 212.732 317.335 206.152C317.558 205.985 317.779 205.823 318 205.666C317.778 205.828 317.557 205.99 317.335 206.152C305.436 215.096 290.5 239.415 290.5 261.574V676.402C290.5 716.913 278.198 756.439 255.222 789.804L140 957.125Z",
    fill: "#CE9578"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.74 954V870.738H988.008V853.785H1067.65V870.738H1037.98V954H1017.74Z",
    fill: "#CE9578"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.5 954V853.785H1110.78L1128.96 922.145L1146.94 853.785H1177.29V954H1158.5V875.113L1138.6 954H1119.12L1099.3 875.113V954H1080.5Z",
    fill: "#CE9578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/Logo-short.45b4cecb6bf8020570ee97260c2bc42f.svg";
export { ForwardRef as ReactComponent };